var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 48,
    viewBox: "0 0 200 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Taphere2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M187.172 37.8657C178.619 37.8657 173.364 32.3015 173.364 23.4401C173.364 14.7847 178.671 8.96289 186.863 8.96289C194.23 8.96289 200 13.5997 200 23.1309V25.2948H180.886C180.886 29.5194 183.411 32.147 187.326 32.147C189.902 32.147 191.757 31.0135 192.53 29.3134H199.794C198.712 34.4654 194.075 37.8657 187.172 37.8657ZM180.886 20.5034H192.787C192.787 17.1031 190.417 14.6816 187.017 14.6816C183.514 14.6816 181.015 17.2834 180.886 20.5034Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M154.818 37.3017V9.32622H162.186V14.1691H162.495C163.525 10.7173 166.101 8.91406 169.244 8.91406C170.017 8.91406 170.996 9.0171 171.665 9.17166V15.9723C170.944 15.7662 169.502 15.5602 168.42 15.5602C164.968 15.5602 162.443 17.9816 162.443 21.3819V37.3017H154.818Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M137.2 37.8657C128.648 37.8657 123.393 32.3015 123.393 23.4401C123.393 14.7847 128.699 8.96289 136.891 8.96289C144.258 8.96289 150.029 13.5997 150.029 23.1309V25.2948H130.915C130.915 29.5194 133.439 32.147 137.355 32.147C139.931 32.147 141.785 31.0135 142.558 29.3134H149.822C148.741 34.4654 144.104 37.8657 137.2 37.8657ZM130.915 20.5034H142.816C142.816 17.1031 140.446 14.6816 137.045 14.6816C133.542 14.6816 131.043 17.2834 130.915 20.5034Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M100.517 21.1233V37.3006H92.8916V0H100.311V14.2196H100.62C101.908 10.9738 104.741 8.96451 108.966 8.96451C114.788 8.96451 118.652 12.88 118.652 19.4746V37.3006H111.027V20.8141C111.027 17.3623 109.172 15.3015 105.978 15.3015C102.783 15.3015 100.517 17.4138 100.517 21.1233Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.7939 47.8091V9.32353H68.3159V14.0119H68.625C69.6554 11.745 71.9223 8.96289 76.6106 8.96289C82.7931 8.96289 87.9451 13.7543 87.9451 23.337C87.9451 32.6622 82.9991 37.7627 76.6106 37.7627C72.0253 37.7627 69.7069 35.1351 68.625 32.8167H68.4189V47.8091H60.7939ZM68.2644 23.2855C68.2644 28.3345 70.4282 31.6833 74.1892 31.6833C78.1047 31.6833 80.1655 28.2314 80.1655 23.2855C80.1655 18.3911 78.1047 15.0423 74.1892 15.0423C70.3767 15.0423 68.2644 18.2365 68.2644 23.2855Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.0361 29.4679C30.0361 23.234 35.0851 21.1732 40.4432 20.8641C42.4525 20.7353 46.2135 20.5549 47.3984 20.5034V18.2365C47.3469 15.9181 45.7498 14.5271 42.9162 14.5271C40.3402 14.5271 38.6915 15.712 38.2794 17.6183H31.015C31.4787 12.7754 35.7034 8.96289 43.1223 8.96289C49.2016 8.96289 54.9719 11.6935 54.9719 18.4426V37.299H47.7591V33.435H47.553C46.1619 36.011 43.5344 37.8142 39.3613 37.8142C34.0032 37.8142 30.0361 35.0321 30.0361 29.4679ZM37.352 29.2618C37.352 31.4257 39.1037 32.5591 41.5251 32.5591C44.977 32.5591 47.45 30.2407 47.3984 27.3041V25.2433C46.2392 25.2948 42.9935 25.4751 41.6797 25.6039C39.0522 25.8615 37.352 27.098 37.352 29.2618Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 6.3885V0H30.5515V6.3885H19.114V37.3006H11.4375V6.3885H0Z",
    fill: "#5E42E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroLogo);
export default __webpack_public_path__ + "static/media/intro_logo.0c05d7a1f64b7446e63c505430504922.svg";
export { ForwardRef as ReactComponent };